import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import configData from './Config.json';
import Spinner from './Spinner.js';

import { serialize, isUnicode, findLocation, suggestLocation } from './Utils/text.js';
import FileUploader from './FileUploader.js';
import SpecsComponent from './SpecsComponent.js';
import Select from './Utils/select.js'
import Credits from './Credits.js'
import Save from './Utils/save.js'
import TextArea from './Utils/textarea.js'
import Input from './Utils/input.js'

import './MyListings.css'

export function MyListings({ state, setState }) {
    const [mylistings, setMylistings] = useState([]);
    const [search, setSearch] = useState('');

    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState('');

    const handleEdit = (listingid) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <EditListing state={state} setState={setState} listingid={listingid} />, modaltype: 'large', modaltitle: 'Edit Listing' }))
    }

    const handleSave = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <Save state={state} setState={setState} listings={mylistings} />, modaltype: 'small', modaltitle: 'Save' }))
    }

    useEffect(() => {
        setLoading(true);
        setResult('');

        const timeoutId = setTimeout(() => {
            const data = {
                countryid: state.selectedcountry,
                userid: state.user.userid,
                searchstring: search,
            };
            axios.post(configData.SECUREURL + configData.GETMYLISTINGS, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                },
            }).then(res => {
                console.log(res.data)
                if (res.data && res.data.code === 1) {
                    setMylistings(res.data.data);
                    if (res.data.data.length === 0) {
                        setResult('No listings found.');
                    }
                } else {
                    setResult('No listings');
                }
            }).catch(() => {
                console.error('Couldn\'t fetch')
                setResult('Error fetching listings')
            }).finally(() => {
                setLoading(false)
            })
        }, 1500);

        return () => clearTimeout(timeoutId);
    }, [search]);

    return (
        <div className='myposts'>

            <div className='modal_row'>
                <div className='modal_buttons'>
                    <div className='modal_buttoncontainer'>
                        <div className='inputgroup'>
                            <div className='inputlabel'>Search</div>
                            <input
                                className='input'
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                                autoComplete="off"
                            />
                        </div>
                    </div>
                    <div className='modal_buttoncontainer'>
                        <button
                            className='button'
                            onClick={() => handleSave()}
                            type='button'
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div>

            <div className='modal_row'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>
                                <input type="checkbox" />
                            </th>
                            <th>ID</th>
                            <th>Date</th>
                            <th>Type</th>
                            <th>Agreement</th>
                            <th>Community</th>
                            <th>Description</th>
                            <th>Views</th>
                        </tr>
                    </thead>
                    <tbody>
                        {result && <tr><td colSpan={8} className='mylistings_nolistings'>{result}</td></tr>}
                        {loading && <tr><td colSpan={8}><Spinner loading={loading} /></td></tr>}
                        {mylistings.map((listing, index) => (
                            <tr key={'listing' + index}
                                onClick={() => handleEdit(listing.id)}>
                                <td>
                                    <input type="checkbox" name={'listing' + index} />
                                </td>
                                <td>{listing.id}</td>
                                <td>{moment(listing.timestamp * 1000).format('MMMM Do YYYY, h:mm:ssA')}</td>
                                <td>{listing.type}</td>
                                <td>{listing.agreement}</td>
                                <td>{listing.community}</td>
                                <td>{listing.description.length > 100 ? listing.description.slice(0, 100) + '...' : listing.description}</td>
                                <td>{listing.counter}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export function AddListing({ state, setState }) {
    const [locations, setLocations] = useState([]);
    const [credits, setCredits] = useState(0);

    const [description, setDescription] = useState('');

    const [advertisingno, setAdvertisingno] = useState('');

    const [smartsearch, setSmartsearch] = useState('');
    const [smartsearchloading, setSmartsearchloading] = useState(false);
    const [smartsearchresult, setSmartsearchresult] = useState([]);
    const [smartsearchtimeout, setSmartsearchtimeout] = useState(null);

    const [parserlocations, setParserlocations] = useState([]);

    const [fullmenu, setFullmenu] = useState([]);
    const [district, setDistrict] = useState('');

    const [communities, setCommunities] = useState([]);
    const [community, setCommunity] = useState('');

    const [type, setType] = useState('');
    const [agreement, setAgreement] = useState('');

    const [media, setMedia] = useState([]);

    const [moredetails, setMoreDetails] = useState(false);
    const [specs, setSpecs] = useState({});

    const [parser, setParser] = useState({});

    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState('');

    const handleUserCredits = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <Credits state={state} setState={setState} />, modaltype: 'small', modaltitle: 'Credits' }))
    }

    const handleAddMedia = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <AddMedia state={state} setState={setState} />, modaltype: 'large', modaltitle: 'Add Media' }))
    }

    useEffect(() => {
        setCredits(state.user.usercredits);
    }, [state.user.usercredits]);

    useEffect(() => {
        if (district) {
            const selecteddistrict = fullmenu.find(d => d.id == district)
            console.log(selecteddistrict)

            if (selecteddistrict) {
                setCommunities(selecteddistrict.communities)
                setCommunity(selecteddistrict.communities[0]?.id)
            }
        }
        else {
            setCommunity('')
        }
    }, [district]);

    useEffect(() => {
        const selectedCountry = state.countries.find(country => country.id == state.selectedcountry);

        if (!selectedCountry) {
            console.error('Selected country not found');
            return;
        }

        const localStorageKey = selectedCountry.dir + 'fullmenu';
        const storedCountryDirFullMenu = JSON.parse(localStorage.getItem(localStorageKey));

        if (storedCountryDirFullMenu && (Date.now() - storedCountryDirFullMenu.timestamp < 10 * 24 * 60 * 60 * 1000)) {
            setFullmenu(storedCountryDirFullMenu.fullmenu)
        }
        else {
            const data = {
                countryid: state.selectedcountry,
            };

            axios.post(configData.SECUREURL + configData.GETFULLMENU, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then(res => {
                if (res.data instanceof Array) {
                    const newCountryDirFullMenu = {
                        timestamp: Date.now(),
                        fullmenu: res.data
                    };
                    localStorage.setItem(selectedCountry.dir + 'fullmenu', JSON.stringify(newCountryDirFullMenu));
                    setFullmenu(res.data)
                }
            }).catch(() => {
                console.error('Error fetching fullmenu')
            })
        }
    }, []);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (description !== '') {
                const data = {
                    countryid: state.selectedcountry,
                    text: description
                };

                axios.post(configData.SECUREURL + configData.GETBOTREPLY, data, {
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json;charset=UTF-8",
                        "userid": state.user.userid,
                        "usertoken": state.user.usertoken
                    }
                }).then(res => {
                    console.log(res.data)
                    if (res.data instanceof Object) {
                        setParser(res.data);
                    }
                }).catch(() => { })
            }
        }, 2000);

        return () => clearTimeout(timeoutId);
    }, [description]);

    useEffect(() => {
        if (parser && parser.room && parser.room.data && parser.room.data.length > 0) {
            let foundtype = state.types.filter((typ) => typ.name == parser.room.value)
            setType(foundtype[0].id)
        }
        if (parser && parser.apartment && parser.apartment.data && parser.apartment.data.length > 0) {
            let foundtype = state.types.filter((typ) => typ.name == parser.apartment.value)
            setType(foundtype[0].id)
        }
        if (parser && parser.building && parser.building.data && parser.building.data.length > 0) {
            let foundtype = state.types.filter((typ) => typ.name == parser.building.value)
            setType(foundtype[0].id)
        }
        if (parser && parser.duplex && parser.duplex.data && parser.duplex.data.length > 0) {
            let foundtype = state.types.filter((typ) => typ.name == parser.duplex.value)
            setType(foundtype[0].id)
        }
        if (parser && parser.land && parser.land.data && parser.land.data.length > 0) {
            let foundtype = state.types.filter((typ) => typ.name == parser.land.value)
            setType(foundtype[0].id)
        }
        if (parser && parser.office && parser.office.data && parser.office.data.length > 0) {
            let foundtype = state.types.filter((typ) => typ.name == parser.office.value)
            setType(foundtype[0].id)
        }
        if (parser && parser.studio && parser.studio.data && parser.studio.data.length > 0) {
            let foundtype = state.types.filter((typ) => typ.name == parser.studio.value)
            setType(foundtype[0].id)
        }
        if (parser && parser.villa && parser.villa.data && parser.villa.data.length > 0) {
            let foundtype = state.types.filter((typ) => typ.name == parser.villa.value)
            setType(foundtype[0].id)
        }
        if (parser && parser.warehouse && parser.warehouse.data && parser.warehouse.data.length > 0) {
            let foundtype = state.types.filter((typ) => typ.name == parser.warehouse.value)
            setType(foundtype[0].id)
        }
        if (parser && parser.offplan && parser.offplan.data && parser.offplan.data.length > 0) {
            let foundtype = state.types.filter((typ) => typ.name == parser.offplan.value)
            setType(foundtype[0].id)
        }
        if (parser && parser.store && parser.store.data && parser.store.data.length > 0) {
            let foundtype = state.types.filter((typ) => typ.name == parser.store.value)
            setType(foundtype[0].id)
        }
        if (parser && parser.commercial && parser.commercial.data && parser.commercial.data.length > 0) {
            let foundtype = state.types.filter((typ) => typ.name == parser.commercial.value)
            setType(foundtype[0].id)
        }

        if (parser && parser.sale && parser.sale.data && parser.sale.data.length > 0) {
            let foundagreement = state.agreements.filter((agr) => agr.name == parser.sale.value)
            setAgreement(foundagreement[0].id)
        }
        if (parser && parser.rent && parser.rent.data && parser.rent.data.length > 0) {
            let foundagreement = state.agreements.filter((agr) => agr.name == parser.rent.value)
            setAgreement(foundagreement[0].id)
        }

        let locationsfound = findLocation(description, locations);
        setParserlocations(locationsfound)

        if (locationsfound.length == 1) {
            var selecteddistrict = state.menu.filter((item) => item.id === locationsfound[0].district)
            setCommunities(selecteddistrict[0].communities)
            setDistrict(locationsfound[0].district)
            setCommunity(locationsfound[0].community)
            setSmartsearch('')
            setSmartsearchresult([])
        }

        if (locationsfound.length > 1) {
            console.log(locationsfound)
            console.log('More than 1 location found...')
            console.log('Checking if all same')
            const firstLocation = locationsfound[0];
            var selecteddistrict = state.menu.find((item) => item.id === firstLocation.district)

            const sameDistrict = locationsfound.every(loc => loc.district === firstLocation.district);
            const sameCommunity = locationsfound.every(loc => loc.community === firstLocation.community);

            if (sameDistrict && sameCommunity) {
                console.log('All locations are same, switching to first one')
                setCommunities(selecteddistrict?.communities)
                setDistrict(firstLocation.district)
                setCommunity(firstLocation.community)
                setSmartsearch('')
                setSmartsearchresult([])
            }
        }
    }, [parser]);

    function missinginfo(parser) {
        if (parser.spam && parser.spam.data && parser.spam.data.length > 0) {
            return { code: 1, data: "Spam detected" };
        }

        if (parser.hashtags && parser.hashtags.data && parser.hashtags.data.length > 0) {
            return { code: 1, data: "Hashtags not accepted" };
        }

        if (parser.unwanted && parser.unwanted.sentences && parser.unwanted.sentences.length > 0) {
            return { code: 1, data: "Found unwanted data." };
        }

        if (parser.contactnumber && parser.contactnumber.data && parser.contactnumber.data.length == 0) {
            if (parser.link && parser.link.data && parser.link.data.length == 0) {
                return { code: 1, data: "Missing contact number or link" };
            }
        }

        if (parser.sale && parser.sale.data && parser.sale.data.length == 0) {
            if (parser.rent && parser.rent.data && parser.rent.data.length == 0) {
                return { code: 1, data: "Missing sale or rent" };
            }
        }

        const types = ['apartment', 'villa', 'room', 'land', 'warehouse', 'building', 'duplex', 'office', 'studio', 'offplan', 'commercial', 'store'];
        let foundType = false;

        for (const type of types) {
            if (parser[type] && parser[type].data && parser[type].data.length > 0) {
                foundType = true;
                break;
            }
        }

        if (!foundType) {
            return { code: 1, data: "At least one type like apartment / villa / land / studio should be found..." };
        }

        return { code: 0, data: "ok" };
    }

    const handleSubmit = () => {
        setResult('');

        if (credits < 1) {
            setResult('No credits left, please recharge.');
            return
        }

        let missing = missinginfo(parser)
        if (missing.code) {
            setResult(missing.data);
            return
        }

        if (!state.user) {
            setResult('User not logged in');
            return
        }

        if (!description) {
            setResult('Description Missing');
            return
        }
        if (!district) {
            setResult('District Missing');
            return
        }
        if (!type) {
            setResult('Type Missing');
            return
        }
        if (!agreement) {
            setResult('Agreement Missing');
            return
        }

        setLoading(true);

        const addlistingFormData = new FormData();
        addlistingFormData.append('countryid', state.selectedcountry);
        addlistingFormData.append('userid', state.user.userid);
        addlistingFormData.append('description', description);
        addlistingFormData.append('district', district);
        addlistingFormData.append('community', community);
        addlistingFormData.append('type', type);
        addlistingFormData.append('agreement', agreement);

        addlistingFormData.append('specs', JSON.stringify(serialize(specs)));

        axios.post(configData.SECUREURL + configData.ADDLISTING, addlistingFormData, {
            headers: {
                "Content-Type": "multipart/form-data",
                "userid": state.user.userid,
                "usertoken": state.user.usertoken
            },
        }).then(res => {
            console.log(res.data)
            if (res.data instanceof Object) {
                if (res.data.code === 1) {
                    setResult('Success');
                    setState(state => ({
                        ...state,
                        user: {
                            ...state.user,
                            usercredits: state.user.usercredits - 1
                        },
                        modalopen: true,
                        modalcontent: <AddMedia state={state} setState={setState} />,
                        modaltype: 'large',
                        modaltitle: 'Add Media'
                    }));
                }
                else {
                    setResult(res.data.data)
                }
            }
        }).catch(() => {
            setResult('Could not submit listing')
        }).finally(() => {
            setLoading(false)
        })
    }

    const handleSearch = (smartsearch) => {
        if (smartsearch !== '') {
            setSmartsearchloading(true);
            let result = suggestLocation(smartsearch, locations)
            setSmartsearchresult(result);
            setSmartsearchloading(false);
        }
    }

    const handleSmartClick = (smartitem) => {
        var selecteddistrict = fullmenu.filter((item) => item.id === smartitem.district)
        setCommunities(selecteddistrict[0].communities)
        setDistrict(smartitem.district)
        setCommunity(smartitem.community)
        setSmartsearch('')
        setSmartsearchresult([])
    }

    useEffect(() => {
        if (smartsearchtimeout) {
            clearTimeout(smartsearchtimeout)
        }

        setSmartsearchtimeout(setTimeout(() => {
            handleSearch(smartsearch)
        }, 700))
    }, [smartsearch])

    function Summary({ parser }) {
        if (typeof parser !== 'object') return null;

        const validKeys = ['apartment', 'building', 'contactnumber', 'duplex', 'land', 'links', 'office', 'price', 'rent', 'room', 'sale', 'size', 'studio', 'villa'];

        return (
            <div
                className='addlisting_summary'
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '8px',
                    padding: '10px',
                    background: '#f5f6f7',
                    borderRadius: '8px'
                }}
            >
                {
                    Object.entries(parser)
                        .filter(([key, value]) => validKeys.includes(key) && value.data && value.data.length > 0)
                        .map(([key, value]) => (
                            <div
                                key={key}
                                style={{
                                    padding: '7px 10px',
                                    background: '#fff',
                                    border: '1px solid #ddd',
                                    borderRadius: '6px'
                                }}
                            >
                                <strong style={{ fontSize: '12px', textTransform: 'capitalize' }}>
                                    {key}
                                </strong>

                                {value.data instanceof Array && value.data.map((string, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            fontSize: '13px',
                                            color: '#555',
                                            marginTop: '2px'
                                        }}
                                    >
                                        {string}
                                    </div>
                                ))}
                            </div>
                        ))
                }

                {
                    parserlocations instanceof Array &&
                    parserlocations.map((location, index) => (
                        <div
                            key={'location' + index}
                            style={{
                                padding: '7px 10px',
                                background: '#fff',
                                border: '1px solid #ddd',
                                borderRadius: '6px'
                            }}
                        >
                            <strong style={{ fontSize: '12px' }}>
                                Location
                            </strong>

                            <div style={{ fontSize: '13px', color: '#555' }}>
                                {location.keyword}
                            </div>
                        </div>
                    ))
                }
            </div>
        );
    }

    return (
        <div className='modal_body'>
            <div className='modal_printable'>
                <div className='addlisting'>
                    <div className='modal_row'>
                        <div className='mylistings_usercredits' onClick={() => handleUserCredits()}>
                            Credits left: {credits}
                        </div>
                    </div>

                    <div className='modal_row'>
                        <TextArea value={description} setValue={setDescription} length={5000} label='Enter description' />
                    </div>

                    {state.selectedcountry == 5 &&
                        <input
                            placeholder='FAL License Information / رقم المعلن'
                            value={advertisingno}
                            onChange={e => setAdvertisingno(e.target.value)}
                            spellCheck={false}
                        />
                    }

                    <div className='modal_row'>
                        <Summary parser={parser} />
                    </div>

                    <div className='modal_row'>
                        <SmartSearch state={state} setDistrict={setDistrict} setCommunities={setCommunities} setCommunity={setCommunity} />
                    </div>

                    <div className='modal_row'>
                        <Select data={fullmenu} itemid={district} setItemid={setDistrict} label='District' />
                    </div>

                    <div className='modal_row'>
                        <Select data={communities} itemid={community} setItemid={setCommunity} label='Community' />
                    </div>

                    <div className='modal_row'>
                        <Select data={state.types} itemid={type} setItemid={setType} label='Type' />
                    </div>

                    <div className='modal_row'>
                        <Select data={state.agreements} itemid={agreement} setItemid={setAgreement} label='Agreement' />
                    </div>

                    <div className='modal_row'>
                        <button className='button' onClick={() => setMoreDetails(!moredetails)} >{moredetails ? 'Less details 🔼' : 'More details 🔽'}</button>
                    </div>

                    {
                        moredetails &&
                        <SpecsComponent type={type} agreement={agreement} outputData={(arg) => setSpecs(arg)} />
                    }

                    <div className='addlisting_spinnercontainer'>
                        <Spinner loading={loading} size={30} />
                    </div>

                </div>
            </div>

            <div className='modal_actions'>
                {result && <div className='modal_result'>{result}</div>}
                <div className='modal_buttons'>
                    <div className='modal_buttoncontainer'>
                        <button
                            className='modal_button'
                            onClick={() => handleSubmit()}
                            type='button'
                            disabled={loading || state.user.usercredits < 1}
                        >
                            Add Listing
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

function SmartSearch({ state, setDistrict, setCommunities, setCommunity }) {
    const [search, setSearch] = useState('');
    const [locations, setLocations] = useState([]);

    const [filteredresults, setFilteredresults] = useState([]);

    const [smartsearchresult, setSmartsearchresult] = useState([]);
    const [smartsearchloading, setSmartsearchloading] = useState(false);

    useEffect(() => {
        const selectedCountry = state.countries.find(country => country.id == state.selectedcountry);

        if (!selectedCountry) {
            console.error('Selected country not found');
            return;
        }

        const localStorageKey = selectedCountry.dir + 'keywords';
        const storedCountryDirKeywords = JSON.parse(localStorage.getItem(localStorageKey));

        if (storedCountryDirKeywords && (Date.now() - storedCountryDirKeywords.timestamp < 10 * 24 * 60 * 60 * 1000)) {
            setLocations(storedCountryDirKeywords.keywords)
        }
        else {
            const data = {
                countryid: state.selectedcountry,
            };

            axios.post(configData.SECUREURL + configData.GETLOCATIONS, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then(res => {
                if (res.data instanceof Object) {
                    const newCountryDirKeywords = {
                        timestamp: Date.now(),
                        keywords: res.data.data
                    };
                    localStorage.setItem(selectedCountry.dir + 'keywords', JSON.stringify(newCountryDirKeywords));
                    setLocations(res.data.data)
                }
            }).catch(() => {
                console.error('Error fetching locations')
            })
        }
    }, []);

    useEffect(() => {
        const query = search.trim().toLowerCase();

        if (!query) {
            setFilteredresults([]);
            return;
        }

        const timer = setTimeout(() => {
            const results = [];
            for (let i = 0; i < locations.length; i++) {
                const loc = locations[i];
                const keyword = loc.keyword ? String(loc.keyword).toLowerCase() : '';

                if (keyword.includes(query)) {
                    results.push(loc);
                    if (results.length >= 50) break;
                }
            }
            setFilteredresults(results);
        }, 1000);

        return () => clearTimeout(timer);
    }, [search, locations]);

    const handleSmartClick = (location) => {
        console.log(state)
        var selecteddistrict = state.menu.find((district) => district.id == location.districtid)
        console.log(selecteddistrict)
        if (selecteddistrict) {
            setCommunities(selecteddistrict.communities)
            setDistrict(location.districtid)
            setCommunity(location.communityid)
            setSearch('')
            setFilteredresults([])
        }
    }

    {
        (!smartsearchloading && smartsearchresult.length > 0) && (
            <div className="addlisting_smartsearchclearbutton" onClick={() => { setSearch(''); setSmartsearchresult([]) }}>
                Clear Button
            </div>
        )
    }
    return (
        <div className='smartsearch'>
            <Input value={search} setValue={setSearch} label='Search Locations' />
            <Spinner loading={smartsearchloading} size={15} />
            <div className='smartsearchlocations'>
                {
                    filteredresults.map((location, index) =>
                        <div
                            key={'location' + index}
                            className='smartsearchlocation'
                            onClick={() => handleSmartClick(location)}
                        >
                            {location.keyword}, {location.districtname}, {location.communityname}
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export function EditListing({ state, setState, listingid }) {
    const [locations, setLocations] = useState([]);
    const [confirmationmodal, setConfirmationmodal] = useState(false);

    const [media, setMedia] = useState([]);
    const [previewimages, setPreviewimages] = useState([]);
    const [imagesToRemove, setImagesToRemove] = useState([]);

    const [description, setDescription] = useState('');

    const [advertisingno, setAdvertisingno] = useState('');

    const [fullmenu, setFullmenu] = useState([]);
    const [district, setDistrict] = useState(0);
    const [communities, setCommunities] = useState([]);
    const [community, setCommunity] = useState(0);
    const [type, setType] = useState(0);
    const [agreement, setAgreement] = useState(1);

    const [moredetails, setMoreDetails] = useState(false);
    const [specs, setSpecs] = useState({});

    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);

    useEffect(() => {
        setResult('');
        setLoading(true)
        const data = {
            countryid: state.selectedcountry,
            listingid: listingid
        };

        axios.post(configData.SECUREURL + configData.GETLISTING, data, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                "userid": state.user.userid,
                "usertoken": state.user.usertoken
            },
        }).then(res => {
            if (res.data instanceof Object) {
                if (res.data.code === 1) {
                    setPreviewimages(res.data.data.images)
                    setDescription(res.data.data.descriptionraw)
                    setDistrict(parseInt(res.data.data.district))
                    let communitiesReceived = state.menu.filter((item) => {
                        return parseInt(item.id) === parseInt(res.data.data.district);
                    })
                    if (communitiesReceived.length > 0) {
                        setCommunities(communitiesReceived[0].communities);
                    }
                    setCommunity(res.data.data.community)
                    setAgreement(res.data.data.agreement)
                    setType(res.data.data.type)
                    setSpecs(res.data.data.specs)
                }
                else {
                    setResult(res.data.data)
                }
            }
        }).catch(() => {
            setResult('Error')
        }).finally(() => {
            setLoading(false)
        })
    }, [listingid, state.id])

    const handleUpdate = e => {
        e.preventDefault();
        setLoading(true);
        setResult(null);

        if (!state.user) {
            setResult('User not logged in');
            setLoading(false)
            return
        }
        if (!description) {
            setResult('Description Missing');
            setLoading(false)
            return
        }
        if (!district) {
            setResult('District Missing');
            setLoading(false)
            return
        }
        if (!community) {
            setResult('Community Missing');
            setLoading(false)
            return
        }

        const editlistingFormData = new FormData();
        editlistingFormData.append('countryid', state.selectedcountry);
        editlistingFormData.append('userid', state.user.userid);
        editlistingFormData.append('listingid', listingid);
        editlistingFormData.append('description', description);
        editlistingFormData.append('district', district);
        editlistingFormData.append('community', community);
        editlistingFormData.append('type', type);
        editlistingFormData.append('agreement', agreement);
        for (let i = 0; i < media.length; i++) {
            editlistingFormData.append('file' + i, media[i]);
        }
        editlistingFormData.append('imagestoremove', JSON.stringify(imagesToRemove));
        editlistingFormData.append('specs', JSON.stringify(specs));

        axios.post(configData.SECUREURL + configData.UPDATELISTING, editlistingFormData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                "userid": state.user.userid,
                "usertoken": state.user.usertoken
            },
        }).then(res => {
            setResult(null);
            if (res.data.code === 1) {
                setResult(res.data.data)
                setState(state => ({
                    ...state,
                    modalopen: true,
                    modalcontent: <AddMedia state={state} setState={setState} />,
                    modaltype: 'large',
                    modaltitle: 'Add Media'
                }));
            }
            else {
                setResult(res.data.data)
            }
        }).catch(() => {
            setResult('Could not update listing')
        }).finally(() => {
            setLoading(false)
        })
    }

    const handleConfirm = () => {
        setConfirmationmodal(false);
        handleDelete();
    };

    const handleCancelModal = () => {
        setConfirmationmodal(false);
    };

    const handleDelete = () => {
        setLoading(true);
        setResult(null);

        const data = {
            countryid: state.selectedcountry,
            listingid: listingid
        };
        axios.post(configData.SECUREURL + configData.REMOVELISTING, data, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                "userid": state.user.userid,
                "usertoken": state.user.usertoken
            },
        }).then(res => {
            if (res.data instanceof Object) {
                if (res.data.code === 1) {
                    setResult('Listing successfully removed')
                }
                else {
                    setResult('Could not remove Listing')
                }
            }
        }).catch(() => {
            setLoading(false)
        }).finally(() => {
            setLoading(false)
        })
    }

    const handleCancel = () => {
        setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null }));
    }

    return (
        <div className='modal_body'>
            <div className='modal_printable'>
                <div className='editlisting'>
                    <div className='editlisting_listingid'>Listing ID {listingid}</div>

                    <div className='modal_row'>
                        <TextArea value={description} setValue={setDescription} length={5000} label='Enter description' />
                    </div>

                    {state.selectedcountry == 5 &&
                        <input
                            placeholder='FAL License Information / رقم المعلن'
                            value={advertisingno}
                            onChange={e => setAdvertisingno(e.target.value)}
                            spellCheck={false}
                        />
                    }

                    <div className='modal_row'>
                        <SmartSearch state={state} setDistrict={setDistrict} setCommunities={setCommunities} setCommunity={setCommunity} />
                    </div>

                    <div className='modal_row'>
                        <Select data={fullmenu} itemid={district} setItemid={setDistrict} label='District' />
                    </div>

                    <div className='modal_row'>
                        <Select data={communities} itemid={community} setItemid={setCommunity} label='Community' />
                    </div>

                    <div className='modal_row'>
                        <Select data={state.types} itemid={type} setItemid={setType} label='Type' />
                    </div>

                    <div className='modal_row'>
                        <Select data={state.agreements} itemid={agreement} setItemid={setAgreement} label='Agreement' />
                    </div>

                    <div className='modal_row'>
                        <button className='button' onClick={() => setMoreDetails(!moredetails)} >{moredetails ? 'Less details 🔼' : 'More details 🔽'}</button>
                    </div>

                    {
                        moredetails &&
                        <SpecsComponent type={type} agreement={agreement} outputData={(arg) => setSpecs(arg)} />
                    }

                    <div className='modal_row'>
                        <FileUploader media={media} setMedia={setMedia} />
                    </div>

                    <div className='addlisting_spinnercontainer'>
                        <Spinner loading={loading} size={30} />
                    </div>

                    {
                        confirmationmodal && (
                            <div className='editlisting_confirmationmodal'>
                                <p className='editlisting_confirmationtext'>Are you sure ?</p>
                                <button className='editlisting_confirmationbutton' onClick={handleConfirm}>Confirm</button>
                                <button className='editlisting_confirmationbutton' onClick={handleCancelModal}>Cancel</button>
                            </div>
                        )
                    }
                </div>
            </div>

            <div className='modal_actions'>
                {result && <div className='modal_result'>{result}</div>}
                <div className='modal_buttons'>
                    <div className='modal_buttoncontainer'>
                        <button onClick={handleUpdate} className='modal_button' type='button'>Update</button>
                    </div>
                    <div className='modal_buttoncontainer'>
                        <button onClick={() => setConfirmationmodal(true)} className='modal_button'>Remove</button>
                    </div>
                    <div className='modal_buttoncontainer'>
                        <button onClick={handleCancel} className='modal_button' type='button'>Cancel</button>
                    </div>
                </div>
            </div>

        </div>
    )
}

export function AddMedia({ state, setState }) {
    const [media, setMedia] = useState([]);

    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState('');

    const handleSubmit = () => {
        setResult('');
        setLoading(true)

        if (!state.user) {
            setResult('User not logged in');
            return
        }

        setLoading(true);

        const addlistingFormData = new FormData();
        for (let i = 0; i < media.length; i++) {
            addlistingFormData.append('file' + i, media[i]);
        }

        axios.post(configData.SECUREURL + configData.ADDMEDIA, addlistingFormData, {
            headers: {
                "Content-Type": "multipart/form-data",
                "userid": state.user.userid,
                "usertoken": state.user.usertoken
            },
        }).then(res => {
            console.log(res.data)
            if (res.data instanceof Object) {
                if (res.data.code === 1) {
                    setResult('Success');
                    setState(state => ({
                        ...state,
                        user: {
                            ...state.user,
                            usercredits: state.user.usercredits - 1
                        }
                    }));
                }
                else {
                    setResult(res.data.data)
                }
            }
        }).catch(() => {
            setResult('Could not submit listing')
        }).finally(() => {
            setLoading(false)
        })
    }

    return (
        <div className='modal_body'>
            <div className='modal_printable'>
                <div className='modal_row'>
                    <FileUploader media={media} setMedia={setMedia} />
                </div>

                <div className='addlisting_spinnercontainer'>
                    <Spinner loading={loading} size={30} />
                </div>

            </div>

            <div className='modal_actions'>
                {result && <div className='modal_result'>{result}</div>}
                <div className='modal_buttons'>
                    <div className='modal_buttoncontainer'>
                        <button
                            className='mylistings_addbutton'
                            onClick={() => handleSubmit()}
                            type='button'
                        >
                            {loading ? "Uploading" : "Add Media"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}